// extracted by css-extract-rspack-plugin
export default {"popoverItem":"styles_popoverItem__+8cag","folderIcon":"styles_folderIcon__Z0nWz","trigger":"styles_trigger__X-PiA","active":"styles_active__Xdokk"};